import { Routes } from '@angular/router';

import { MainComponent } from './shared/layout/main.component';
import { AuthContainerComponent } from './features/auth/auth.container';
import { AboutContainerComponent } from './features/about/about.container';
import { OverviewContainerComponent } from './features/overview/overview.container';
import { AuthenticatedGuard } from './global/authenticated.guard';
import { PerformanceContainerComponent } from './features/performance/performance.container';
import { HoldingsContainerComponent } from './features/holdings/holdings.container';
import { CashFlowContainerComponent } from './features/cash-flow/cash-flow.container';
import { TransactionsContainerComponent } from './features/transactions/transactions.container';
import { StatementsContainerComponent } from './features/statements/statements.container';
import { DocumentsContainerComponent } from './features/documents/documents.container';
import { TransactionsSummaryComponent } from './features/transactions/transactions-summary/transactions-summary.component';
import { TransactionsDetailsComponent } from './features/transactions/transactions-details/transactions-details.component';
import { HelpAndContactsContainerComponent } from './features/help-and-contacts/help-and-contacts.container';
import { HelpComponent } from './features/help-and-contacts/help/help.component';
import { ContactUsComponent } from './features/help-and-contacts/contact-us/contact-us.component';
import { MyContactsComponent } from './features/help-and-contacts/my-contacts/my-contacts.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { LoginComponent } from './features/auth/login/login.component';
import { TermsAndConditionsComponent } from './features/auth/terms-and-conditions/terms-and-conditions.component';
import { AdditionalAuthenticationComponent } from './features/auth/additional-authentication/additional-authentication.component';
import { EmailSentComponent } from './features/auth/email-sent/email-sent.component';
import { ProfileContainerComponent } from './features/profile/profile.container';
import { DetailsComponent } from './features/profile/details/details.component';
import { PreferencesComponent } from './features/profile/preferences/preferences.component';
import { DataTablesComponent } from './features/profile/data-tables/data-tables.component';
import { ReportsContainerComponent } from './features/reports/reports.container';
import { MssoBypassContainerComponent } from './features/msso-bypass/msso-bypass.container';
import { LoginGuard } from './global/login.guard';
import { ValuationsContainerComponent } from './features/valuations/valuations.container';
import { ProfileReportsComponent } from './features/profile/reports/reports.component';
import { NotificationsComponent } from './features/profile/notifications/notifications.component';
import { TermsOfUseContainerComponent } from './features/terms-of-use/terms-of-use.container';
import { DisclaimersComponent } from './features/disclaimers/disclaimers.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { MyConnectionsComponent } from './features/help-and-contacts/my-connections/my-connections.component';
import { EsgComponent } from './features/esg/esg.component';
import { TaxDetailsComponent } from './features/tax-details/tax-details.component';

export const ROUTES: Routes = [
  {
    path: 'login',
    component: MssoBypassContainerComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'provision',
    component: AuthContainerComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginGuard]
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      },
      {
        path: 'terms-and-conditions',
        component: TermsAndConditionsComponent
      },
      {
        path: 'additional-authentication',
        component: AdditionalAuthenticationComponent
      },
      {
        path: 'email-sent',
        component: EmailSentComponent
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent
      },
    ]
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseContainerComponent
  },
  {
    path: 'disclaimers',
    component: DisclaimersComponent
  },
  {
    path: 'disclaimers/:country',
    component: DisclaimersComponent
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [LoginGuard, AuthenticatedGuard],
    children: [
      { path: 'about', component: AboutContainerComponent, canActivate: [AuthenticatedGuard] },
      {
        path: 'contacts',
        component: HelpAndContactsContainerComponent,
        canActivate: [AuthenticatedGuard],
        canActivateChild: [AuthenticatedGuard],
        children: [
          { path: '', redirectTo: 'my-contacts', pathMatch: 'full' },
          /* {
            path: 'help',
            component: HelpComponent
          }, */
          {
            path: 'contact-us',
            component: ContactUsComponent
          },
          {
            path: 'my-contacts',
            component: MyContactsComponent
          },
          {
            path: 'my-connections',
            component: MyConnectionsComponent
          },

        ]
      },
      { path: 'overview', component: OverviewContainerComponent, canActivate: [AuthenticatedGuard] },
      { path: 'valuation', component: ValuationsContainerComponent, canActivate: [AuthenticatedGuard] },
      { path: 'performance', component: PerformanceContainerComponent, canActivate: [AuthenticatedGuard] },
      { path: 'holdings', component: HoldingsContainerComponent, canActivate: [AuthenticatedGuard] },
      { path: 'esg', component: EsgComponent, canActivate: [AuthenticatedGuard] },
      { path: 'cash-flow', component: CashFlowContainerComponent, canActivate: [AuthenticatedGuard] },
      {
        path: 'transactions',
        component: TransactionsContainerComponent,
        canActivate: [AuthenticatedGuard],
        canActivateChild: [AuthenticatedGuard],
        children: [
          { path: '', redirectTo: 'summary', pathMatch: 'full' },
          { path: 'summary', component: TransactionsSummaryComponent },
          { path: 'details', component: TransactionsDetailsComponent }
        ]
      },
      { path: 'statements', component: StatementsContainerComponent, canActivate: [AuthenticatedGuard] },
      { path: 'documents', component: DocumentsContainerComponent, canActivate: [AuthenticatedGuard] },
      { path: 'reports', component: ReportsContainerComponent, canActivate: [AuthenticatedGuard] },
      {
        path: 'profile',
        component: ProfileContainerComponent,
        canActivate: [AuthenticatedGuard],
        canActivateChild: [AuthenticatedGuard],
        children: [
          { path: '', redirectTo: 'details', pathMatch: 'full' },
          { path: 'details', component: DetailsComponent },
          { path: 'preferences', component: PreferencesComponent },
          { path: 'data-tables', component: DataTablesComponent },
          { path: 'reports', component: ProfileReportsComponent },
          { path: 'notifications', component: NotificationsComponent }
        ]
      },
      { path: 'tax-details', component: TaxDetailsComponent, canActivate: [AuthenticatedGuard] }
    ]
  }
];
